import React, { Fragment, useState, useEffect } from "react";
import notesIcon from "./../../../assets/images/notes.svg";
import Card from "../OfficeOptions/Card";
import Page from "components/Page";
import constants from "./../../../constants";
import styles from "./Contracts/Contracts.module.scss";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { decodeId, getStorage } from "utils";
import {
  useOfficeDetail,
  useStaffByUserId,
} from "repositories/office-repository";
import useSubscriptionAccess from "hooks/useSubscriptionAccess";
import { useSelector } from "react-redux";
import Text from "components/Text";

function Forms({ t, history, location }) {
  let { officeId } = useParams();
  const modulesAccess = useSelector((prev) => prev);
  const profile = useSelector((state) => state.userProfile.profile);
  const decodeOfficeId = parseInt(decodeId(officeId));
  const { data: officeDetail } = useOfficeDetail(decodeOfficeId);
  const isStaff = profile?.role?.systemRole === constants?.systemRoles?.staff;
  const { redirectWithCheck, isModuleDisabledClass } = useSubscriptionAccess();
  const [selectedPlanFeature, setSelectedPlanFeature] = useState({});
  let isFromStaffAdmin = getStorage(constants.notes.cache.isFromStaffAdmin);

  const { data: staffDetail } = useStaffByUserId(decodeOfficeId, profile?.id);

  useEffect(() => {
    if (modulesAccess && isStaff) getFormContractsModuleAccess();
  }, [modulesAccess]);

  const getFormContractsModuleAccess = () => {
    try {
      const subscription = modulesAccess?.Subscription;

      if (subscription?.length) {
        const selectedPlanData = subscription?.find(
          (val) => val?.ownerId === officeDetail?.ownerId
        );
        setSelectedPlanFeature(selectedPlanData);
      }
    } catch {}
  };

  const goBack = () => {
    if (profile?.role?.systemRole === constants.systemRoles.accountOwner) {
      history.push(
        constants.routes.accountOwner.officeOptions.replace(
          ":officeId",
          officeId
        )
      );
    } else if (staffDetail?.isAdmin) {
      const route = isFromStaffAdmin
        ? constants.routes.staff.officeOptions
        : constants.routes.staff.officeAdmin;
      history.push(route.replace(":officeId", officeId));
    } else {
      history.push(
        constants.routes.staff.officeOptions.replace(":officeId", officeId)
      );
    }
  };

  const isMyForms = location?.pathname.includes("my-forms");

  const redirectPathToContacts = isMyForms
    ? constants.routes.staff.officeContracts
    : constants.routes.accountOwner.contracts;
  const redirectPathToEmploymentProof = isMyForms
    ? constants.routes.accountOwner.myEmployementProof
    : constants.routes.accountOwner.employementProof;

  return (
    <Fragment>
      <Page onBack={goBack} title={t("contracts.formsAndContract")}>
        <Text size="14" weight="300" color="#000000">
          {officeDetail?.name}
        </Text>
        <div className={styles.gridContainer}>
          <div
            className={isModuleDisabledClass(
              constants.moduleNameWithId.formAndContracts,
              isStaff ? selectedPlanFeature : null
            )}
          >
            <Card
              to={redirectPathToContacts.replace(":officeId", officeId)}
              icon={notesIcon}
              title={t("contracts.viewContract")}
              officeName={officeDetail?.name}
              redirectTo={() =>
                redirectWithCheck(
                  {
                    pathname: redirectPathToContacts.replace(
                      ":officeId",
                      officeId
                    ),
                    state: location.state,
                  },
                  !!isModuleDisabledClass(
                    constants.moduleNameWithId.formAndContracts,
                    selectedPlanFeature
                  )
                )
              }
            />
          </div>
          <Card
            to={redirectPathToEmploymentProof.replace(":officeId", officeId)}
            icon={notesIcon}
            title={t("employmentProof.employmentProof")}
            officeName={officeDetail?.name}
          />
        </div>
      </Page>
    </Fragment>
  );
}

export default withTranslation()(Forms);
